module.exports = __webpack_public_path__ + "img/forensic_photography_methods_splash.0ba61f88.jpg";